import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=5178f608&scoped=true"
import script from "./ActiveFilters.vue?vue&type=script&lang=js"
export * from "./ActiveFilters.vue?vue&type=script&lang=js"
import style0 from "./ActiveFilters.vue?vue&type=style&index=0&id=5178f608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5178f608",
  null
  
)

export default component.exports